import React, { useState, useEffect } from "react";
import { TestarSegurancaSenha } from "./functions";
import "./SegurancaSenha.css";

type SegurancaDeSenhaProps = {
  senha: string;
};

const SegurancaDeSenha = ({
  senha
}: SegurancaDeSenhaProps) => {
  const [tamanhoSenha, setTamanhoSenha] = useState(false);
  const [caractereEspecial, setCaracterEspecial] = useState(false);
  const [letraMaiuscula, setLetraMaiuscula] = useState(false);
  const [letraMinuscula, setLetraMinuscula] = useState(false);
  const [numeros, setNumeros] = useState(false);
  const [validacao, setValidacao] = useState(false);

  useEffect(() => {
    TestarSegurancaSenha(senha, setValidacao, setTamanhoSenha, setCaracterEspecial, setLetraMaiuscula, setLetraMinuscula, setNumeros,);
  }, [senha]);


  return (
    <>
      {validacao && senha.length !== 0 && (
        <div className="password-rules" aria-live="polite">
          <p className="password-rules-title">
            Para validar a senha:
          </p>
          <p className={caractereEspecial ? "valid" : "invalid"}>
            Caracteres especiais
          </p>
          <p className={numeros ? "valid" : "invalid"}>
            Números
          </p>
          <p className={letraMaiuscula ? "valid" : "invalid"}>
            Letras maiúsculas
          </p>
          <p className={letraMinuscula ? "valid" : "invalid"}>
            Letras minúsculas
          </p>
          <p className={tamanhoSenha ? "valid" : "invalid"}>
            No mínimo 7 caracteres
          </p>
        </div>
      )}
    </>
  );
};

export default SegurancaDeSenha;
